<app-detail-header-template>
  <div top-left>
    <div class="container-back-button">
      <app-back-button [text]="backButtonText"></app-back-button>
    </div>
    <h3 class="container-emrId" (click)="navigateNewDesign()">
      {{addressText | uppercase}}
    </h3>
  </div>
  <div top-right>
    <div class="emr-item bold"> {{emrLocationText | uppercase}}</div>
    <div class="emr-retrieval-type bold">
      EMR <app-icon-stack iconName="laptop" iconBase="circle"></app-icon-stack>
    </div>
  </div>
  <div bottom-left>
    <app-sub-menu [menuItems]="menuItems"></app-sub-menu>
  </div>
  <div bottom-right>
    <app-button class="header-button" text="EDIT ADDRESS" (onClick)="showEditEmrModal()"></app-button>
    <retrieval-emr-detail-edit [isCreateVisible]="isEmrEditView" (formClose)="receiveEmrEditValue($event)"></retrieval-emr-detail-edit>

    <p-splitButton class="spilt-button-class" label="CHANGE RETRIEVAL METHOD" [model]="assignmentItems" menuStyleClass="menuPosRight"></p-splitButton>
    <retrieval-address-assignment [documentSourceId]="emrId" [chases]=chaseList [isCreateVisible]="isAddressAssignmentView" (formClose)="receiveAddressAssignmentValue($event)"></retrieval-address-assignment>
    <retrieval-emr-assignment [documentSourceId]="emrId" [chases]=chaseList [isCreateVisible]="isEmrAssignmentView" (formClose)="receiveEmrAssignmentValue($event)"></retrieval-emr-assignment>
    <retrieval-ft-assignment [documentSourceId]="emrId" [chases]=chaseList [isCreateVisible]="isFTAssignmentView" (formClose)="receiveFTAssignmentValue($event)"></retrieval-ft-assignment>

    <app-button class="header-button" text="NEXT ADDRESS" [ngClass]="isFinishCall ? 'show-call-button':'hide-call-button'" (onClick)="getNextAddress()"></app-button>
    <app-button class="header-button" text="CALL {{phoneNumber | phoneNumber}}" [ngClass]="!isFinishCall ? 'show-call-button':'hide-call-button'" (onClick)="showCallPopover($event)" #call></app-button>

    <app-popover #callPopOver [isPinned]="true">
      <app-iframe [visible]="display" [load]="display" iframeSrc="{{ twiliourl }}" iframeWidth="{{ twilioWidth }}" iframeHeight="{{ twilioHeight }}"></app-iframe>
      <app-button text="Hangup" (onClick)="endCallOnHangup()"></app-button>
    </app-popover>

  </div>
</app-detail-header-template>
